import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { CreditPayment } from '../state/types'

export const useCreditPaymentLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadCreditPayment = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.CREDIT_PAYMENTS, id, dbRequest) as Promise<O<CreditPayment>>
        }

        const loadCustomerCreditPayments = async (customerId: string) => {
            const { loadMultiple } = loaders(companyId)
            const options = {
                valueFilters: getActiveFilter().valueFilters!.concat([
                    { prop: 'customerId', value: customerId }
                ])
            }
            const response = await loadMultiple(TableName.CREDIT_PAYMENTS, options)
            return response.dataTypes as CreditPayment[]
        }

        const loadCustomersCreditPayments = (
            customerIds: string[],
            dbRequest = false
        ) => {
            const { loadFilteredByList } = loaders(companyId)
            return loadFilteredByList(TableName.CREDIT_PAYMENTS, dbRequest, 'customerId', customerIds) as Promise<CreditPayment[]>
        }

        const countCreditPayments = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.CREDIT_PAYMENTS, options)
        }
        
        return {
            loadCreditPayment,
            loadCustomerCreditPayments,
            loadCustomersCreditPayments,
            countCreditPayments
        }
    }
}
